// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freeze[data-v-e9f10d58]{position:sticky;left:0;background:#fff;z-index:1}", ""]);
// Exports
module.exports = exports;
